import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { SRBMDetailData } from 'api/traps/SRBMTraps/types';
import CustomPlaceholder from 'components/Utils/CustomPlaceHolder';
import DeviceLinkCell from 'components/TrapsTables/Cells/LinkCell/DevicesLinkCall';

interface SideTableWithDataProps {
  data: SRBMDetailData | null;
  isLoading: boolean;
  slug: string;
}

const SideTableWithData: React.FC<SideTableWithDataProps> = ({ data, isLoading }) => {
  const { t } = useTranslation();
  const shouldShowLastService = () => {
    if (!data?.last_maintenance || !data?.date_of_installation) return false;

    const lastMaintenanceDate = new Date(data.last_maintenance).getTime();
    const installationDate = new Date(data.date_of_installation).getTime();

    return lastMaintenanceDate > installationDate;
  };
  return (
    <div className="card card-animate shadow-lg">
      <div className="card-body text-center align-content-center py-5">
        <div className="card-body">
          <div className="table-card">
            <table className="table mb-0 table-sm">
              <tbody>
                <tr>
                  <td className="fw-medium align-content-center text-start">
                    {t('MCTDetail.TrapDataTableCard.last_maintance')}
                  </td>
                  <td className="align-content-center text-center ">
                    {isLoading ? (
                      <CustomPlaceholder colSize={12} />
                    ) : shouldShowLastService() ? (
                      dayjs(data?.last_maintenance).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm')
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
                <tr className="my-2">
                  <td className="fw-medium text-start py-3">{t('MCTDetail.TrapDataTableCard.serialNumber')}</td>
                  <td className="w-50">
                    {isLoading ? <CustomPlaceholder colSize={10} /> : `${data?.serial_number || 'N/A'}`}
                  </td>
                </tr>
                <tr className="py-2">
                  <td className="fw-medium text-start py-2">{t('MCTDetail.TrapDataTableCard.model')}</td>
                  <td className="align-content-center">
                    {isLoading ? <CustomPlaceholder colSize={12} /> : `${data?.model}`}
                  </td>
                </tr>
                <tr>
                  <td className="fw-medium text-start py-2">{t('MCTDetail.TrapDataTableCard.no')}</td>
                  <td className="align-content-center">
                    {isLoading ? <CustomPlaceholder colSize={2} /> : `${data?.sequence_number}`}
                  </td>
                </tr>
                <tr>
                  <td className="fw-medium text-start py-2">{t('MCTDetail.TrapDataTableCard.installDate')}</td>
                  <td className="align-content-center">
                    {isLoading ? (
                      <CustomPlaceholder colSize={7} />
                    ) : (
                      `${data?.date_of_installation ? data?.date_of_installation : '-'}`
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="fw-medium text-start py-2">{t('SBSDetail.sideTable.standartBaitAmountPerStation')}</td>
                  <td className="align-content-center">
                    {isLoading ? <CustomPlaceholder colSize={2} /> : `${data?.start_bait_filling}`}
                  </td>
                </tr>
                <tr>
                  <td className="fw-medium text-start py-2">{t('SBSDetail.sideTable.eatenBaitAmount')}</td>
                  <td className="align-content-center">
                    {isLoading ? <CustomPlaceholder colSize={2} /> : `${data?.eaten_bait_from_last_add}`}
                  </td>
                </tr>
                <tr>
                  <td className="fw-medium text-start py-2">{t('SBSDetail.sideTable.currentBait')}</td>
                  <td className="align-content-center">
                    {isLoading ? <CustomPlaceholder colSize={2} /> : `${data?.bait_filling}`}
                  </td>
                </tr>
                <tr>
                  <td className="fw-medium text-start py-2">{t('MCTDetail.TrapDataTableCard.hub')}</td>
                  <td className="align-content-center">
                    {isLoading ? <CustomPlaceholder colSize={9} /> : `${data?.hub}`}
                  </td>
                </tr>
                <tr>
                  <td className="fw-medium text-start py-2 ">{t('MCTDetail.TrapDataTableCard.map')}</td>
                  <td className="align-content-center">
                    {isLoading ? (
                      <CustomPlaceholder colSize={12} />
                    ) : (
                      <DeviceLinkCell
                        data={data?.default_plan ?? null}
                        icon="ri-treasure-map-line"
                        slug={data?.object.slug}
                      />
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="fw-medium text-start py-2">{t('MCTDetail.TrapDataTableCard.battery')}</td>
                  <td className="align-content-center">
                    {isLoading ? <CustomPlaceholder colSize={3} /> : `${data?.battery_percentage} %`}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideTableWithData;
